<template>
  <v-layout row wrap fill-height style="padding: 10px;">
      <v-flex fill-height d-flex xs12>
        <v-card style="width: 100%" :loading="isLoading">
          <v-card-actions>
            <modal-area @save="newArea" />
          </v-card-actions>
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="4" xl="4">
                <v-select
                  :items="sortedMapItems"
                  item-text="name"
                  return-object
                  v-model="selectedMapArea"
                  :label="$$t('mapItems')"
                ></v-select>
              </v-col>
            </v-row>
            <FormMapItem
              :MapItem="editMapItem"
              :isSaving="isSaving"
              @save="save"
              @cancel="$router.push({name: from.name })" />
            <v-toolbar
              dense
              floating
              style="width: 100%; heigth: 58px"
            >
              <v-btn icon @click="setCurrentPos">
                <v-icon>{{ mdiCrosshairsGps }}</v-icon>
              </v-btn>
              <GmapAutocomplete @place_changed="setPlace">
              </GmapAutocomplete>
              <v-btn @click="usePlace" icon color="success">
                <v-icon>{{ mdiMagnify }}</v-icon>
              </v-btn>
              <label class="ml-10 mr-2">
                {{ $$t('manageCoordinates') }}
              </label>
              <v-btn-toggle mandatory v-model="toggleButton">
                <v-btn>
                  {{ $$t('area') }}
                </v-btn>
                <v-btn>
                  {{ $$t('pointOfInterest')}}
                </v-btn>
                <v-btn>
                  Deaktiveer
                </v-btn>
              </v-btn-toggle>
              <v-spacer></v-spacer>
              <v-btn-toggle class="ml-20">
                <v-menu
                  v-if="toggleButton === 1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ $$t(pointOfInterestType) }}
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      @click="pointOfInterestType = type"
                      v-for="type in pointsOfInterestTypes"
                      :key="type"
                    >
                      <v-list-item-title>{{ $$t(type) }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-btn-toggle>
            </v-toolbar>
            <GmapMap ref="map"
              :center="mapPos"
                :zoom="12"
                style="width: 100%; height: 900px"
                @click="mapClick"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: true,
                  streetViewControl: false,
                  rotateControl: true,
                  fullscreenControl: true,
                  disableDefaultUi: false
                }"
              >
              <GmapPolygon :paths="paths" :editable="true" @paths_changed="updateEdited($event)"
                @click="polygonClick"
                :options="{
                  strokeColor: editMapItem.strokeColour,
                }">
              </GmapPolygon>
              <GmapMarker
                v-for="(pointOfInterest, i) in pointsOfInterest"
                :key="pointOfInterest.id"
                :title="$$t(pointOfInterest.pointOfInterestType)"
                :label="$$t(pointOfInterest.pointOfInterestType)"
                :position="pointOfInterest.location"
                @dragend="passthroughPointDragEnd"
                :clickable="true"
                :draggable="true"
                :options="{
                  strokeColor: editMapItem.strokeColour,
                }"
                @dblclick="removePointOfInterest(pointOfInterest)"
                @click="toggleInfoWindow(pointOfInterest,i)"
              />
              <GmapInfoWindow
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen=false"
              >
                <v-textarea
                  :label="$$t('description')"
                  v-model="selectedPointOfInterest.description"
                ></v-textarea>
                <v-btn
                  color="error"
                  class="mr-2"
                  @click="removePointOfInterest(selectedPointOfInterest)"
                >
                  {{ $t('common.buttons.delete') }}
                </v-btn>
                <v-btn
                  color="success"
                  @click="savePointOfInterest(selectedPointOfInterest)"
                  :loading="isSaving">
                  {{ $t('common.buttons.save') }}
                </v-btn>
              </GmapInfoWindow>
            </GmapMap>
          </v-card-text>
        </v-card>
      </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { mdiCrosshairsGps, mdiMagnify } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import org from '@codehq/aurora-app-core/src/mixins/org';
import FormMapItem from '../components/FormMapItem.vue';
import ModalArea from '../components/ModalArea.vue';
import location from '../mixins/location';

export default {
  components: {
    FormMapItem,
    ModalArea,
  },
  mixins: [location, loading, org],
  name: 'EditMap',
  module: 'Membership',
  data() {
    return {
      mdiCrosshairsGps,
      mdiMagnify,
      currentPointOfInterest: {},
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        content: '',
        // optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      currentMidx: null,
      content: '',
      /**
      * Get/Set editing MapItem. Default to {}.
      */
      editMapItem: {
        strokeColour: '#518fc8',
      },
      valid: false,
      localMyLocation: {},
      mapPos: { lat: -28, lng: 26 },
      selectedMapArea: undefined,
      markers: [],
      place: null,
      edited: null,
      paths: [],
      pointOfInterestType: 'passthroughPoint',
      selectedPointOfInterest: {},
      pointsOfInterest: [],
      pickupPoints: [],
      pickupPoint: undefined,
      toggleButton: undefined,
    };
  },
  computed: {
    ...mapGetters('mapItems', ['sortedMapItems']),
    ...mapState('mapItems', ['mapItems']),
    ...mapState('organizations', ['organization']),
  },
  watch: {
    selectedMapArea: {
      immediate: true,
      deep: true,
      async handler() {
        await this.refresh();
      },
    },
  },
  async mounted() {
    // At this point, the child GmapMap has been mounted, but
    // its map has not been initialized.
    // Therefore we need to write mapRef.$mapPromise.then(() => ...)
    this.isLoading = true;
    await this.LOAD_mapItems();
    this.isLoading = false;
    if (navigator.geolocation) {
      this.setCurrentPos();
    } else {
      this.$log.warn('Geolocation is not supported by this browser.');
    }
  },
  created() {
    document.addEventListener('keydown', this.saveKey);
    this.$root.$on('organization.changed', async () => {
      this.$log.info('organization.changed');
      this.selectedMapArea = null;
      await this.refresh();
    });
  },
  destroyed() {
    document.removeEventListener('keydown', this.saveKey);
    this.$root.$off('organization.changed');
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('mapItems', ['LOAD_mapItems', 'CREATE_mapItemModel', 'UPDATE_mapItemModel']),
    ...mapActions('pointsOfInterest', ['LOAD_pointsOfInterest', 'CREATE_pointOfInterest', 'UPDATE_pointOfInterest', 'DELETE_pointOfInterest']),
    async newArea(mapItem) {
      const result = await this.CREATE_mapItemModel(mapItem);
      await this.$nextTick();
      await this.LOAD_mapItems();
      await this.$nextTick();
      this.selectedMapArea = this.mapItems.find((m) => m.id === result.id);
      this.isLoading = false;
      this.$root.$emit('toast:notify', this.$t('common.phrases.savedSuccessfully'));
    },
    saveKey(e) {
      if (e.ctrlKey && e.key === 's') {
        // Prevent the Save dialog to open
        e.preventDefault();
        this.save(this.editMapItem);
      }
    },
    /** Method used parse server geography to google lantLng
     */
    parseMapItemPoint(point) {
      if (!point) {
        return undefined;
      }
      const coord = point?.geography?.wellKnownText?.replace('POINT ', '')
        .replace('(', '')
        .replace(')', '');
      const coordArr = coord.split(/[ ,]+/);
      const lat = parseFloat(coordArr[1]);
      const lng = parseFloat(coordArr[0]);
      this.$log.info(coordArr);
      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);
      return latLng;
    },
    /** Method used to save the item
     */
    async save(mapItem) {
      this.isLoading = true;
      this.$log.info(this.mode);
      if (this.mode === 'add') {
        await this.CREATE_mapItemModel(mapItem);
      } else {
        await this.UPDATE_mapItemModel(mapItem);
      }
      await this.$nextTick();
      await this.LOAD_mapItems();
      await this.$nextTick();
      this.selectedMapArea = this.mapItems.find((m) => m.id === this.selectedMapArea.id);
      this.isLoading = false;
      this.$root.$emit('toast:notify', this.$t('common.phrases.savedSuccessfully'));
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.location;
      this.selectedPointOfInterest = marker;

      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.currentMidx = idx;
        this.infoWinOpen = true;
        this.$log.info('opened info window');
      }
    },
    async loadPointsOfInterest() {
      try {
        const pointsOfInterest = await this.LOAD_pointsOfInterest(this.editMapItem.id);
        this.pointsOfInterest = pointsOfInterest.map((p) => ({
          description: p.description,
          mapItemId: this.selectedMapArea.id,
          pointOfInterestType: p.pointOfInterestType,
          location: this.parseMapItemPoint(p.location),
          id: p.id,
        }));
      } catch (error) {
        this.$log.error(error);
      }
    },
    polygonClick(e) {
      this.$log.trace(e);
      this.mapClick(e);
    },
    passthroughPointDragEnd(e) {
      this.$log.trace(e);
      this.toggleButton = 1;
      this.mapClick(e);
    },
    pickupPointDragEnd(e) {
      this.$log.trace(e);
      this.toggleButton = 2;
      this.mapClick(e);
    },
    async mapClick(e) {
      switch (this.toggleButton) {
        case 0:
          this.paths.push(e.latLng);
          break;
        case 1:
          // point of interest
          // eslint-disable-next-line no-case-declarations
          const pointOfInterest = await this.CREATE_pointOfInterest({
            orgId: this.organization?.id,
            mapItemId: this.selectedMapArea.id,
            location: `POINT (${e.latLng.lng()} ${e.latLng.lat()})`,
            pointOfInterestType: this.pointOfInterestType,
          });
          this.pointsOfInterest.push({
            orgId: this.organization?.id,
            mapItemId: this.selectedMapArea.id,
            pointOfInterestType: this.pointOfInterestType,
            location: e.latLng,
            description: e.description,
            id: pointOfInterest.id,
          });
          break;
        default:
          break;
      }
    },
    async refresh() {
      this.$log.debug('refreshing');
      this.isLoading = true;
      await this.LOAD_mapItems();
      this.isLoading = false;
      this.paths = [];
      this.passthroughPoint = this.parseMapItemPoint(this.selectedMapArea?.passthroughPoint);
      this.pickupPoint = this.parseMapItemPoint(this.selectedMapArea?.pickupPoint);
      let polygonText = this.selectedMapArea?.points?.geography?.wellKnownText;
      polygonText = polygonText?.replace('POLYGON ', '')
        .replace('((', '')
        .replace('))', '');
      const coords = polygonText?.split(', ') ?? [];
      coords.forEach((coord) => {
        // eslint-disable-next-line space-in-parens
        const coordArr = coord.split(/[ ,]+/);
        const lat = parseFloat(coordArr[1]);
        const lng = parseFloat(coordArr[0]);
        // eslint-disable-next-line no-undef
        const latLng = new google.maps.LatLng(lat, lng);
        this.paths.push(latLng);
      });
      this.editMapItem = { ...this.selectedMapArea };
      if (this.editMapItem?.id) {
        await this.loadPointsOfInterest();
      }
    },
    setCurrentPos() {
      const self = this;
      navigator.geolocation.getCurrentPosition((pos) => {
        self.mapPos = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        self.$refs.map.$mapPromise.then((map) => {
          map.panTo(self.mapPos);
        });
      });
    },
    async savePointOfInterest(pointOfInterest) {
      const { description, id } = pointOfInterest;
      this.isSaving = true;
      await this.UPDATE_pointOfInterest({
        description,
        id,
      });
      this.isSaving = false;
      this.$root.$emit('toast:notify', this.$t('common.phrases.savedSuccessfully'));
    },
    updateEdited(mvcArray) {
      const paths = [];
      const points = [];
      for (let i = 0; i < mvcArray.getLength(); i += 1) {
        const path = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j += 1) {
          const point = mvcArray.getAt(i).getAt(j);
          path.push({ lat: point.lat(), lng: point.lng() });
          points.push(`${point.lng()} ${point.lat()}`);
        }
        paths.push(path);
      }
      if (points[0] !== points[points.length - 1]) {
        this.$log.info('invalid polygon, fixing');
        points.push(points[0]);
      }
      this.editMapItem.points = {
        geography: {
          wellKnownText: `POLYGON ((${points.join(', ')}))`,
        },
      };
      this.$log.trace(this.editMapItem.points);
    },
    async removePointOfInterest(pointOfInterest) {
      await this.DELETE_pointOfInterest(pointOfInterest.id);
      this.infoWinOpen = false;
      await this.loadPointsOfInterest();
      this.$root.$emit('toast:notify', this.$t('common.phrases.savedSuccessfully'));
    },
    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      this.$refs.map.$mapPromise.then((map) => {
        this.$log.info(place);
        map.panTo(place.geometry.location);
      });
      // this.place = place;
    },
    usePlace() {
      if (this.place) {
        this.$refs.map.$mapPromise.then((map) => {
          map.panTo({
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          });
          this.place = null;
        });
      }
    },
  },
};
</script>
<style scoped>
.v-toolbar__content {
  width: 100%;
  height: 58px;
}
</style>
